import { createRoot } from "react-dom/client";
import HotelsBooking from "./hotels-booking";
import "./hotels-booking.css";

const root = document.getElementById("hotels-booking-root");

if (root) {
  createRoot(root).render(<HotelsBooking />);
}

export default HotelsBooking;


